import { render, staticRenderFns } from "./Copywrinting.vue?vue&type=template&id=4f7a6e19&"
import script from "./Copywrinting.vue?vue&type=script&lang=js&"
export * from "./Copywrinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports